import { Component, OnInit, Injector } from '@angular/core';
import { BitfBreadcrumbsComponent } from '../../bitf-breadcrumbs.component';

@Component({
  selector: 'bitf-mat-breadcrumbs',
  templateUrl: './bitf-mat-breadcrumbs.component.html',
  styleUrls: ['./bitf-mat-breadcrumbs.component.scss'],
})
export class BitfMatBreadcrumbsComponent extends BitfBreadcrumbsComponent implements OnInit {
  constructor(public injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
